import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const DOMAIN = "https://skylinebussiness.com"; // ✅ change if needed

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* 1. COMPANY INFO */}
        <section className="footer-section brand-info">
          <h2>Skyline Bussiness Solutions</h2>

          <p>
            Innovating the Digital Frontier. We engineer scalable systems for 
            modern enterprises with global standards.
          </p>

          <div className="footer-status">
            <span className="dot"></span> SYSTEM ACTIVE
          </div>

          {/* ✅ Quick WhatsApp CTA */}
          <a
            href="https://wa.me/919630085601?text=Hello%20Skyline%20Business%20Solutions"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-whatsapp"
          >
            Chat on WhatsApp →
          </a>
        </section>

        {/* 2. QUICK LINKS */}
        <nav className="footer-section" aria-label="Footer Navigation">
          <h3>Expertise</h3>
          <ul>
            <li><Link to="/seo-services">SEO & Marketing</Link></li>
            <li><Link to="/online-branding">Branding</Link></li>
            <li><Link to="/video-editing">Content Creation</Link></li>
            <li><Link to="/product-photography">Product Shoot</Link></li>
          </ul>
        </nav>

        {/* 3. CONTACT */}
        <section className="footer-section">
          <h3>Contact</h3>

          <address>
            <p>
              <strong>P:</strong>{" "}
              <a href="tel:+919630085601">+91 96300 85601</a>
            </p>

            <p>
              <strong>E:</strong>{" "}
              <a href="mailto:skylinebussinesssolutions@gmail.com">
                skylinebussinesssolutions@gmail.com
              </a>
            </p>

            <p className="address-text">
              Livewire Building, 2nd Floor,<br />
              Near Bharat Petroleum,<br />
              Bombay Hospital Area, Indore
            </p>

            {/* ✅ Open in Google Maps */}
            <a
              href="https://maps.google.com/?q=22.7638972,75.9055063"
              target="_blank"
              rel="noopener noreferrer"
              className="map-link"
            >
              View on Map →
            </a>
          </address>
        </section>

        {/* 4. MAP */}
        <section className="footer-section map-section">
          <h3>Location</h3>

          <div className="map-wrapper">
            <iframe
              title="Skyline Bussiness Solutions Location"
              src="https://www.google.com/maps?q=22.7638972,75.9055063&z=15&output=embed"
              width="100%"
              height="150"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>
          © 2026 Skyline Bussiness Solutions · All Rights Reserved ·{" "}
          <a href={`${DOMAIN}/privacy-policy`}>Privacy Policy</a>
        </p>

        {/* SOCIAL LINKS */}
        <div className="footer-socials">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
          <a href="https://www.instagram.com/skylinebussinesssolutions/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <a href="https://x.com/i/flow/login?redirect_after_login=%2Fhome" target="_blank" rel="noopener noreferrer">
            X
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;